import { Brand } from 'common/Brand';

export interface BrandIconHrefs {
  favicon: string;
  touchIcon: string;
}

export const BRAND_ICON_HREFS: Record<Brand, BrandIconHrefs> = {
  [Brand.Shef]: { favicon: '/favicon.png', touchIcon: '/favicon.png' },
  [Brand.TableRun]: { favicon: '/favicon-tablerun.png', touchIcon: '/apple-touch-icon-tablerun.png' },
};
